import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPITToolsListId = getEnv('REACT_APP_IT_TOOLS_SP_LIST_ID');
const expand = 'expand=fields(select=ID, Title, eDescription)';

export class ITToolsService {
  static async getToolsType() {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPITToolsListId}/items?${expand}`))
      .then(res => res.data.value && res.data.value.map((o: any) => ({ ...o.fields })))
      .catch(err => { throw new RequestError(err) });
  }
}
